import type { PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getHomeRouteForRole } from "@/constants/routes";
import { useAuth } from "@/shared/hooks/useAuth";

type ModuleProtectedRouteProps = PropsWithChildren<{
  allowedRoles: string[];
  loginRoute: string;
}>;

const ModuleProtectedRoute = ({
  children,
  allowedRoles,
  loginRoute,
}: ModuleProtectedRouteProps) => {
  const { isAuthenticated, isHydrated, user } = useAuth();
  const location = useLocation();

  if (!isHydrated) {
    return <div style={{ padding: 24 }}>Loading session...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to={loginRoute} replace state={{ from: location.pathname }} />;
  }

  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to={getHomeRouteForRole(user?.role)} replace />;
  }

  return children;
};

export default ModuleProtectedRoute;
